export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-350px.62538be1.jpg";